var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      vectorEffect: "non-scaling-stroke"
    },
    className: "svg-inline--fa fa-star fa-w-18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 22,
    width: 22,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    d: "M 18.85579,6.6893 13.4282,5.85882 11.00232,0.6966 c -0.43465,-0.92015 -1.69403,-0.93185 -2.1324,0 L 6.44404,5.85882 1.01645,6.6893 C 0.04312,6.83746 -0.34695,8.09682 0.3589,8.81813 l 3.92674,4.01593 -0.92875,5.67298 c -0.16717,1.02543 0.86188,1.79352 1.72375,1.31395 l 4.85548,-2.67858 4.85548,2.67858 c 0.86188,0.47567 1.89093,-0.28852 1.72375,-1.31395 L 15.5866,12.83406 19.51334,8.81813 C 20.21919,8.09682 19.82911,6.83746 18.85579,6.6893 Z M 14.637245,12.371801 15.614081,18.97278 9.9843128,16.137604 4.3304482,19.069166 5.4036693,12.588669 0.84712217,7.8520259 7.1675687,6.7511829 9.9843128,0.89873386 12.897442,6.7511829 19.121503,7.7797367 Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStar);
export default __webpack_public_path__ + "static/media/empty_star.adb444a506d15299dc315149ef645297.svg";
export { ForwardRef as ReactComponent };